import angular from 'angular';

export default angular.module('disable-get-cache', []).config(DisableGetCache);

function DisableGetCache($httpProvider) {
  // Disable $http cache
  $httpProvider.defaults.cache = false;

  // Initialize get if not there
  if (!$httpProvider.defaults.headers.get) {
    $httpProvider.defaults.headers.get = {};
  }

  // Disable caching for all GET calls... thanks IE!
  let getHeaders = $httpProvider.defaults.headers.get;

  // Might not need all of these, but there are multiple articles dating back
  // to 2008 about the issue of IE caching every request. These are the
  // proposed solutions that should, in theory, cover every case.
  //
  // REF: https://support.microsoft.com/en-us/kb/234067
  getHeaders['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
  getHeaders['Cache-Control'] = 'no-cache,no-store';
  getHeaders['Pragma'] = 'no-cache';
  getHeaders['Expires'] = -1;
}
